import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BlogCTAButtons from "@/components/BlogCTAButtons";
import CanonicalTag from "@/components/CanonicalTag";
import FloatingADUWizard from "@/components/FloatingADUWizard";
import FloatingReserveButton from "@/components/FloatingReserveButton";
import heroImage from "@/assets/backyard-usable-living-space.png";

const BlogBackyardLivingSpace = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": "Turning Your Backyard Into Usable Living Space",
    "description": "Better layout, more privacy, outdoor connection. Learn how an ADU can transform your backyard.",
    "datePublished": "2026-04-06",
    "author": { "@type": "Organization", "name": "UDA ADU" },
    "publisher": { "@type": "Organization", "name": "UDA ADU" },
  };

  return (
    <div className="min-h-screen bg-background">
      <CanonicalTag url="https://www.udaadu.com/blogs/backyard-usable-living-space" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
      <Navigation />
      <div className="w-full max-w-5xl mx-auto px-4 pt-8">
        <img src={heroImage} alt="Turning your backyard into usable living space" className="w-full rounded-2xl" />
      </div>
      <main className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/blogs" className="inline-flex items-center text-muted-foreground hover:text-foreground mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4 mr-2" /> Back to Blog
        </Link>
        <p className="text-sm text-muted-foreground mb-2">April 6, 2026</p>
        <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-8">Turning Your Backyard Into Usable Living Space</h1>
        <article className="prose prose-lg max-w-none text-muted-foreground space-y-6">
          <p>Most backyards are underused.</p>
          <p>An ADU changes that completely.</p>
          <p>Instead of just placing a unit in the yard, we look at the entire space. Access paths, privacy, outdoor seating, and how everything connects together.</p>
          <p>This approach makes the property feel intentional, not crowded.</p>
          <p>ADUs are one of the most practical ways to add living space and create rental income on the same property.</p>
          <p>The key is planning the full layout, not just the structure.</p>
        </article>
        <BlogCTAButtons />
      </main>
      <FloatingADUWizard />
      <FloatingReserveButton />
      <Footer />
    </div>
  );
};

export default BlogBackyardLivingSpace;
